// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { CheckEmailAuthEmailCheckPostMutationRequest, CheckEmailAuthEmailCheckPostMutationResponse, CheckEmailAuthEmailCheckPost422 } from "../models/emailAuthController/CheckEmailAuthEmailCheckPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";
import type { MutationObserverOptions, QueryClient } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { checkEmailAuthEmailCheckPost } from "../client/checkEmailAuthEmailCheckPost.ts";
import { useMutation } from "@tanstack/vue-query";

export const checkEmailAuthEmailCheckPostMutationKey = () => [{ url: '/auth/email/check' }] as const

export type CheckEmailAuthEmailCheckPostMutationKey = ReturnType<typeof checkEmailAuthEmailCheckPostMutationKey>

/**
 * @description Check if email is already registered.
 * Returns whether the email exists in the system.
 * @summary Check Email
 * {@link /auth/email/check}
 */
export function useCheckEmailAuthEmailCheckPost<TContext>(options: 
{
  mutation?: MutationObserverOptions<CheckEmailAuthEmailCheckPostMutationResponse, ResponseErrorConfig<CheckEmailAuthEmailCheckPost422>, {data: MaybeRefOrGetter<CheckEmailAuthEmailCheckPostMutationRequest>}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CheckEmailAuthEmailCheckPostMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions?.mutationKey ?? checkEmailAuthEmailCheckPostMutationKey()

          return useMutation<CheckEmailAuthEmailCheckPostMutationResponse, ResponseErrorConfig<CheckEmailAuthEmailCheckPost422>, {data: CheckEmailAuthEmailCheckPostMutationRequest}, TContext>({
            mutationFn: async({ data }) => {
              return checkEmailAuthEmailCheckPost(data, config)
            },
            mutationKey,
            ...mutationOptions
          }, queryClient)
      
}